import React, {forwardRef} from "react";

import {FieldWrapper, IFieldWrapperProps} from "../../atoms/wrapper/FieldWrapper";
import {getErrorMessage} from "../../utils/get_error_message";
import {ITextAreaProps, Textarea} from "./TextArea";

export type ITextareaFieldProps = IFieldWrapperProps & ITextAreaProps;

export const TextareaField = forwardRef<HTMLTextAreaElement, ITextareaFieldProps>((props, textAreaForwardedRef) => {
    const {labelContent, message, id, className, error, fieldState, dataTestId, ...textAreaProps} = props;

    const errorMessage = getErrorMessage(error);

    return (
        <FieldWrapper
            labelContent={labelContent}
            fieldState={fieldState}
            message={errorMessage || message}
            htmlFor={id}
            className={className}
            dataTestId={dataTestId}
        >
            <Textarea {...textAreaProps} ref={textAreaForwardedRef} id={id} />
        </FieldWrapper>
    );
});
